import styles from "./LatestNews.module.scss";
import iconStyles from "../../../components/Icon.module.scss";
import buttonStyles from "../../../components/Button.module.scss";
import ModalWithPicture, {
  ModalWithPictureDialogProps,
  ModalWithPictureHandle,
} from "../../../components/ModalWithPicture/ModalWithPicture";
import { useEffect, useRef, useState } from "react";
import { getExcerpt } from "../../../utils/helpers";
import { getEvents } from "../../../services/getContent";
import Loader from "../../../components/Loader/Loader";

interface NewsData {
  image: string;
  title: string;
  excerpt: string;
  content: string;
  link: string;
}

const getEventSummary = (eventData: any): NewsData => {
  const image = eventData.image;
  const title = eventData.title;
  const content = getExcerpt(eventData.content);
  const excerpt = eventData.excerpt;
  const link = eventData.link;
  const data = { image, title, content, excerpt, link };
  return data;
};

const isValidUrl = (str: string): boolean => {
  try {
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
};

const LatestNews = () => {
  const modalRef = useRef<ModalWithPictureHandle>(null);

  // this is for featuredEvent but turned as for now
  // const [featuredEvent, setFeaturedEvent] = useState({
  //   image: "",
  //   title: "",
  //   content: "",
  //   excerpt: "",
  // });
  const [allEvents, setAllEvents] = useState<NewsData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getEvents()
      .then((events) => setAllEvents(events.map(getEventSummary)))
      .catch((error) => console.error("Unable to load events from Sanity", error))
      .finally(() => setLoading(false));
  }, []);

  const showModal = (dialogProps: ModalWithPictureDialogProps) => {
    modalRef.current?.onOpen(dialogProps);
  };

  return (
    <>
      <section id="latest" className={styles.latest}>
        <div className={styles.title}>
          <h2>Lately at</h2>
          <h3>IREC Stockholm</h3>
        </div>
        <div className={styles["card-container"]}>
          {loading && <Loader />}
          {!loading &&
            allEvents.map((eventContent, _) => {
              if (isValidUrl(eventContent.content)) {
                return (
                  <div className={styles.card} key={eventContent.title}>
                    <img className={styles.post} src={eventContent.image} />
                    <div className={styles.overlay}>
                      <a
                        href={eventContent.content}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <button className={buttonStyles.invert}>
                          <span
                            className={`${iconStyles.icon} ${styles.icon} ${iconStyles.youtube}`}
                          ></span>
                          Watch
                        </button>
                      </a>
                    </div>
                  </div>
                );
              } else {
                const dialogProps: ModalWithPictureDialogProps = {
                  excerpt: eventContent.excerpt,
                  description: eventContent.content,
                  title: eventContent.title,
                  image: eventContent.image,
                };

                return (
                  <div
                    className={styles.card}
                    key={eventContent.title}
                    onClick={() => showModal(dialogProps)}
                  >
                    <img className={styles.post} src={eventContent.image} />
                    <div className={styles.overlay}>
                      <button
                        className={buttonStyles.invert}
                        onClick={() => showModal(dialogProps)}
                      >
                        View details
                      </button>
                    </div>
                  </div>
                );
              }
            })}
        </div>
      </section>

      <ModalWithPicture ref={modalRef} />
    </>
  );
};

export default LatestNews;
